import { Card, CardContent, CardHeader } from "@woba/ds-web";
import { ScoreCardSkeleton } from "@/_old/components/data-display/score-card";
import { VisibleBreakpoint } from "@/_old/components/visible-breakpoint";
import { SkeletonCircle, SkeletonRect } from "@/_old/lib/skeleton";
import { styled } from "@woba/ds-web";
import * as S from "./bookings.styles";

const ItemWrapper = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "$space-03",
});

export const BookingsSkeleton = () => {
  return (
    <Card
      css={{
        flex: 2,
        padding: "$space-06",
        borderColor: "$neutral-200",
        width: "100%",
      }}
    >
      <CardHeader css={{ gap: "$space-04", marginBottom: "$space-05" }}>
        <SkeletonRect height={32} />
        <SkeletonRect height={32} width={100} />
      </CardHeader>
      <CardContent>
        <S.ContainerProducts>
          <SkeletonRect width={312} height={60} />
          <S.PercentContainer>
            <SkeletonRect width={"100%"} height={20} />
          </S.PercentContainer>

          <S.ProductsItems>
            <ItemWrapper css={{ flex: 1 }}>
              <SkeletonRect width={100} height={50} />
            </ItemWrapper>
            <ItemWrapper css={{ flex: 1 }}>
              <SkeletonRect width={100} height={50} />
            </ItemWrapper>
            <ItemWrapper css={{ flex: 1 }}>
              <SkeletonRect width={100} height={50} />
            </ItemWrapper>
            <ItemWrapper css={{ flex: 1 }}>
              <SkeletonRect width={100} height={50} />
            </ItemWrapper>
            <ItemWrapper css={{ flex: 1 }}>
              <SkeletonRect width={100} height={50} />
            </ItemWrapper>
          </S.ProductsItems>
        </S.ContainerProducts>
      </CardContent>
    </Card>
  );
};
